import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useLocation, useNavigate } from "react-router-dom";
import { postData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { MotorKeyValueForm } from "./components/motorKeyValueForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const AddMotorKeyValue = () => {
  
  const navigate = useNavigate();
  const location = useLocation();
  const categoryName = location?.state?.categoryName || "";
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const handleAddMotorKeyValue = async (keyValueData) => {
    const payload = {
      categoryId: keyValueData?.category?.value,
      keyName: keyValueData?.keyName,
      parentKeyId: keyValueData?.parentKeyId?.value || null,
      sortOrder: Number(keyValueData?.sortOrder),
      isActive: keyValueData?.active,
    };
    try {
    const response = await postData(
      "/reference/motor/key-value-store",
      payload
    );
    if(response?.success){
      showSnackbar(response?.message || "Successfully Added","success");
      navigate("/motor-master/motor-keyValue");
    }else{
      showSnackbar(response?.message || "Error Adding","error");
    }
  } catch(error){
      console.error("Error fetching data",error)
      showSnackbar(error?.response?.data?.message, "error");
    }
    finally{
      setCircleLoading(false)
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/motor-master/motor-keyValue")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add {categoryName} Key Value Store Details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add {categoryName} Key Value Store details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorKeyValueForm onsubmit={handleAddMotorKeyValue} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddMotorKeyValue;
